import isEqual from 'lodash/isEqual';
import qs from 'qs';
import { useRef, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';
import { actions } from '../../state/actions.esm.js';
import '../../state/reducer.esm.js';

const useHashParams = (name, enableQueryParams, normalizedFilterConfig, deserialize = (queryParams) => queryParams, serialize = (queryParams) => queryParams) => {
    const history = useHistory();
    const location = useLocation();
    const previousFilters = useRef();
    const previousHash = useRef();
    const { dispatch, filters, initialized } = useFilters(name);
    const originalHash = qs.parse(history.location.hash.replace('#', ''));
    const currentHash = deserialize(originalHash);
    const deserializedHash = Object.entries(currentHash).reduce((accum, [filterName, filterValue]) => {
        var _a, _b;
        accum[filterName] = (_b = (_a = normalizedFilterConfig[filterName]) === null || _a === void 0 ? void 0 : _a.deserialize) === null || _b === void 0 ? void 0 : _b.call(_a, filterValue);
        return accum;
    }, {});
    useEffect(() => {
        if (!enableQueryParams || !initialized)
            return;
        const filtersAndHashMatch = isEqual(deserializedHash, filters);
        const hashChangedByFilterBar = !isEqual(originalHash, currentHash);
        // Compare reference and not values
        const filtersChanged = filters !== previousFilters.current;
        const hashChanged = !isEqual(deserializedHash, previousHash.current);
        const initialReplaceComplete = previousFilters.current;
        if (!filtersAndHashMatch || hashChangedByFilterBar) {
            const serializedFilters = Object.keys(filters).reduce((acc, filterName) => {
                var _a, _b;
                acc[filterName] = (_b = (_a = normalizedFilterConfig[filterName]) === null || _a === void 0 ? void 0 : _a.serialize) === null || _b === void 0 ? void 0 : _b.call(_a, filters[filterName]);
                return acc;
            }, {});
            const newLocation = {
                ...location,
                hash: `#${qs.stringify(serialize(serializedFilters), {
                    arrayFormat: 'brackets'
                })}`
            };
            if (filtersChanged) {
                initialReplaceComplete ? history.push(newLocation) : history.replace(newLocation);
            }
            else if (hashChanged) {
                // Hash can change from going back in browser history, or clicking on a link to the current page with no params set
                // istanbul ignore next
                if (Object.keys(deserializedHash).length === 0) {
                    history.replace(newLocation);
                }
                else {
                    dispatch({
                        type: actions.replaceFilters,
                        payload: {
                            name: name,
                            filters: deserializedHash
                        }
                    });
                }
            }
        }
        previousFilters.current = filters;
        previousHash.current = deserializedHash;
    }, [filters, location.hash, enableQueryParams]);
    return enableQueryParams ? deserializedHash : {};
};

export { useHashParams };
//# sourceMappingURL=useHashParams.esm.js.map
